import React from 'react';
import { ToggleRightIcon, ClockIcon, SparklesIcon } from 'lucide-react';
const highlights = [{
  icon: ToggleRightIcon,
  title: 'El Interruptor de Longevidad',
  text: 'Principios de biohacking que "hackean" su genética para que su cuerpo sane solo.'
}, {
  icon: ClockIcon,
  title: 'Ajustes de 30 segundos',
  text: 'No necesitas ser veterinario ni pasar horas cocinando para tu perro.'
}, {
  icon: SparklesIcon,
  title: 'Energía y anti-envejecimiento',
  text: 'Cambia radicalmente cómo su cuerpo procesa la energía y combate el envejecimiento.'
}];
export function RevelationSection() {
  return <section className="w-full bg-cream-50" aria-labelledby="revelacion-titulo" data-id="element-121" data-mp="jk6rh7tdcj87">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" data-id="element-122" data-mp="em578jk7idv5">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center" data-id="element-123" data-mp="2dxpmoazxfpqc">
          <div data-id="element-124" data-mp="28yv3h7y1rz5p">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.16em] text-clay-600" data-id="element-125" data-mp="28z4kw7510xzs">
              La revelación
            </p>
            <h2 id="revelacion-titulo" className="font-display text-3xl font-bold leading-tight text-forest-900 sm:text-4xl" data-id="element-126" data-mp="1c50wuw8tyzkz">
              Descubrí que existe un "Interruptor de Longevidad" en los perros.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-forest-800/80" data-id="element-127" data-mp="176zeyen556b3">
              Al aplicar principios de Biohacking —ajustes biológicos simples— puedes "hackear" su
              genética para que su cuerpo sane solo. Se trata de pequeños ajustes que cambian
              radicalmente su energía y su envejecimiento.
            </p>
            <ul className="mt-8 space-y-4" data-id="element-128" data-mp="1l70e9pnrc5og">
              {highlights.map(({
              icon: Icon,
              title,
              text
            }) => <li key={title} className="flex gap-4" data-id="element-129" data-mp="1q4ab3qdh7jmb">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-forest-900" data-id="element-130" data-mp="2duwkbkz7v9xw">
                    <Icon className="h-5 w-5 text-clay-400" aria-hidden="true" data-id="element-131" data-mp="2infv6a6irqz0" />
                  </span>
                  <div data-id="element-132" data-mp="2si4qu8hkyr3j">
                    <h3 className="font-semibold text-forest-900" data-id="element-133" data-mp="2sgaf9ks78bc4">{title}</h3>
                    <p className="text-forest-800/75" data-id="element-134" data-mp="2nk3ahvbjh5vr">{text}</p>
                  </div>
                </li>)}
            </ul>
          </div>
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/f701a0af-b272-4d4b-810e-206dcb8d5754.jpg" alt="Ingredientes naturales sobre una mesa: cúrcuma, aceite de coco, vinagre y hierbas frescas" className="aspect-[3/2] w-full rounded-3xl object-cover shadow-lg" data-id="element-135" data-mp="2ejetqsurgrf6" />
        </div>
      </div>
    </section>;
}